// extracted by mini-css-extract-plugin
module.exports = {"row":"AlternativePayments_row__2BYp3"};